import {FeatureType, FeaturePeriod, StorageUnit, TimeUnit, FeatureKey} from './feature-constants.enum';

export const getFeatureUnitConfig = (): {
	[key: string]: {
		units: string[];
		type: FeatureType;
		requiredPeriod?: typeof FeaturePeriod.Lifetime;
		canBeGrouped?: boolean;
	};
} => ({
	[FeatureKey.StorageSpace]: {
		units: [StorageUnit.GB, StorageUnit.TB, StorageUnit.MB, StorageUnit.KB, 'bytes'],
		type: FeatureType.Storage,
		requiredPeriod: FeaturePeriod.Lifetime,
		canBeGrouped: false,
	},
	[FeatureKey.MaxVideoDuration]: {
		units: [TimeUnit.Minutes, TimeUnit.Hours, TimeUnit.Seconds],
		type: FeatureType.Time,
		requiredPeriod: FeaturePeriod.Lifetime,
		canBeGrouped: true,
	},
	[FeatureKey.EncodingMinutes]: {
		units: [TimeUnit.Minutes, TimeUnit.Hours, TimeUnit.Seconds],
		type: FeatureType.Time,
		canBeGrouped: false,
	},
	[FeatureKey.VideoUploads]: {units: ['count'], type: FeatureType.Count, canBeGrouped: false},
	encodes: {units: ['count'], type: FeatureType.Count},
	[FeatureKey.MaxEncodesPerVideo]: {units: ['count'], type: FeatureType.Count, requiredPeriod: FeaturePeriod.Lifetime, canBeGrouped: true},
	[FeatureKey.VideoCodecs]: {units: [], type: FeatureType.String, requiredPeriod: FeaturePeriod.Lifetime, canBeGrouped: true},
	[FeatureKey.MaxVideoResolution]: {
		units: [],
		type: FeatureType.String,
		requiredPeriod: FeaturePeriod.Lifetime,
		canBeGrouped: true,
	},
	[FeatureKey.HdrSupport]: {
		units: [],
		type: FeatureType.Boolean,
		requiredPeriod: FeaturePeriod.Lifetime,
		canBeGrouped: true,
	},
});


export const getFeatureIconMap = (): {[key: string]: string} => ({
	[FeatureKey.StorageSpace]: 'storage',
	[FeatureKey.MaxVideoDuration]: 'schedule',
	[FeatureKey.EncodingMinutes]: 'timer',
	[FeatureKey.VideoUploads]: 'cloud_upload',
	[FeatureKey.MaxEncodesPerVideo]: 'analytics',
	[FeatureKey.VideoCodecs]: 'video_settings',
	[FeatureKey.MaxVideoResolution]: 'high_quality',
	[FeatureKey.HdrSupport]: 'hdr_on',
});
